export default __webpack_public_path__ + "static/media/p4.45834b32.png";